import React from 'react';
import { estadoInicialFiltroUsuario, type ITablaUsuariosVistaProps } from '../interfaces';
import Tabla from '../../../globales/componentes/tabla/tabla';
import { ActionIcon, Group, Tooltip, Text } from '@mantine/core';
import { IconFilter, IconFilterFilled, IconRefresh } from '@tabler/icons-react';
import FiltroUsuariosVista from './filtroUsuariosVista';

const TablaUsuariosVista: React.FunctionComponent<ITablaUsuariosVistaProps> = ({ 
  tabla, 
  consultarUsuarios,
  entidadesFiltro,
  filtro,
  manejarCambioFiltroUsuario,
  limpiarFiltros,
  habilitarFiltros,
  manejarHabilitarFiltros
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflowX: 'hidden' }}>
      <Group justify="space-between" mb="md">
        <Text fw={700} size="lg">Usuarios</Text>
        <Group>
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => consultarUsuarios(estadoInicialFiltroUsuario)}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip>
          </Group>
        </Group>
      </Group>
      {habilitarFiltros && (
        <FiltroUsuariosVista
          consultarUsuarios={consultarUsuarios}
          filtro={filtro}
          manejarCambioFiltroUsuario={manejarCambioFiltroUsuario}
          limpiarFiltros={limpiarFiltros}
          entidadesFiltro={entidadesFiltro}
        />
      )}
      <div style={{ flex: 1, minHeight: 0 }}>
        <Tabla tabla={tabla} />
      </div>
    </div>
  );
};

export default TablaUsuariosVista;
